export class BulkPhotoReportSettings {
  includeInPhotosReport: boolean;
  propertyPhotoIds: string[];

  constructor(includeInPhotosReport: boolean, propertyPhotoIds: string[]) {
    this.includeInPhotosReport = includeInPhotosReport;
    this.propertyPhotoIds = propertyPhotoIds;
  }
}
